// extracted by mini-css-extract-plugin
export default {"pageLayout":"Clients_pageLayout__EBLFL","btn":"Clients_btn__V4omv"};